import { render } from "./ActivitatTutoriaView.vue?vue&type=template&id=67a045e6&scoped=true"
import script from "./ActivitatTutoriaView.vue?vue&type=script&lang=js"
export * from "./ActivitatTutoriaView.vue?vue&type=script&lang=js"

import "./ActivitatTutoriaView.vue?vue&type=style&index=0&id=67a045e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a045e6"]])

export default __exports__